import moment from "moment/moment";

export default function calculateDueDateWithEvery(initiationDate, every) {
    const d = moment(initiationDate);
    if(!every) return d;
    const { time, times } = every;
    return moment(d).add(times, time);
}
